import { attach, sample } from 'effector'
import { repairOrderModel } from '~/entities/RepairOrder'
import { editRepairOrderModel } from '~/features/RepairOrders/EditRepairOrder'
import { RepairOrder } from '~/shared/api'
import { OptionEnum } from '~/shared/config/constants'
import { RepairOrderStatusEnum } from '~/shared/config/enums'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { isString } from '~/shared/lib/utils'

export type StatusFormValues = {
  status?: OptionEnum<RepairOrderStatusEnum> | null
}

export const statusChangeFx = attach({
  effect: repairOrderModel.saveFx,
  source: editRepairOrderModel.$repairOrderId,
  mapParams: (status: StatusFormValues['status'], id) => {
    return new RepairOrder(
      {
        ...(isString(status?.id) && { status: status.id }),
      },
      id as string,
    )
  },
})

sample({
  clock: statusChangeFx.doneData,
  fn() {
    return {
      messageI18n: 'alert.status successfully changed' as const,
      variant: 'success' as const,
    }
  },
  target: snackbarEnqueued,
})
